import isEmpty from 'lodash/isEmpty';

import type { CashbackAgreedTransaction } from 'models/cashBack';
import type { Currency } from 'models/currency';
import type { RootState } from 'reducers/types';
import { getCurrency } from '../currencies';

export const getAgreedTransactionAmount = (state: RootState) => {
  const agreedTransaction = getAgreedTransactionObject(state);

  if (isEmpty(agreedTransaction)) {
    return 0;
  }

  return agreedTransaction.amount;
};

export const getAgreedTransactionCurrencyObject = (state: RootState) => {
  const agreedTransaction = getAgreedTransactionObject(state);
  if (agreedTransaction?.currency) {
    return getCurrency(state, agreedTransaction.currency);
  }

  return {} as Currency;
};

const getAgreedTransactionObject = (
  state: RootState,
): CashbackAgreedTransaction | undefined => {
  const {
    entities: {
      cashback: { agreedTransaction } = {},
    },
  } = state;

  return agreedTransaction;
};
